import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { useI18n } from '../i18n/I18nContext';
import { getLegalCopy } from '../i18n/legalCopy';
import '../style/Homepage.css';

const TermsAndConditions = () => {
  const { language } = useI18n();
  const copy = getLegalCopy(language);
  const page = copy.terms;

  return (
    <div>
      <Header />
      <main className="info-page terms-page">
        <section className="info-hero terms-hero">
          <p className="eyebrow">{page.eyebrow}</p><h1>{page.title}</h1><p>{copy.updated} {page.intro}</p>
        </section>
        <section className="feature-grid info-grid terms-summary-grid" aria-label={page.summaryLabel}>
          {page.cards.map(([title, body]) => <article className="feature-card" key={title}><h3>{title}</h3><p>{body}</p></article>)}
        </section>
        <section className="terms-notice">
          <div><p className="eyebrow">{page.noticeEyebrow}</p><h2>{page.noticeTitle}</h2></div><p>{page.noticeBody}</p>
        </section>
        <section className="terms-content" aria-label={page.fullLabel}>
          {page.sections.map(([title, body]) => <article className="terms-section-card" key={title}><h2>{title}</h2><p>{body}</p></article>)}
        </section>
        <section className="terms-contact-card">
          <div><p className="eyebrow">{page.questions}</p><h2>{page.questionsTitle}</h2></div>
          <p>{page.questionsBody} <Link to="/legal-notice">{copy.common.legal}</Link>.</p>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default TermsAndConditions;
